export const UPDATE_RECENTLY_SAVED_OPT_IN = 'core/UPDATE_RECENTLY_SAVED_OPT_IN';
export const ANY_CHANGE_MADE_SINCE_SAVE = 'core/ANY_CHANGE_MADE_SINCE_SAVE';
export const CLEAR_ANY_CHANGE_MADE_SINCE_SAVE = 'core/CLEAR_ANY_CHANGE_MADE_SINCE_SAVE';
export const TOGGLE_EXPAND_COLLAPSE = 'core/TOGGLE_EXPAND_COLLAPSE';
export const DEFAULT_EXPAND_COLLAPSE = 'core/DEFAULT_EXPAND_COLLAPSE';
export const NEWER_SESSION_REGISTERED = 'core/NEWER_SESSION_REGISTERED';
